// Lib
import React from 'react';
import { TableCell, TableRow as MuiTableRow } from '@mui/material';

const TableRow = ({
  columns,
  useCellsReducers = () => ({ cells: {} }),
  item,
  styles,
}) => {
  const { cells } = useCellsReducers({ order: item });

  return (
    <MuiTableRow className={styles?.row}>
      {columns?.map((column) => {
        return (
          <TableCell key={`${item?.id}-${column?.id}`} className={styles?.cell}>
            {cells?.[column?.id]}
          </TableCell>
        );
      })}
    </MuiTableRow>
  );
};

export default TableRow;
